module.exports = __webpack_public_path__ + "media/images/iconLockClosed__accent-5db9b7bb16a7f68e8d884d350fec90ee.png";